/**
 * Persistance du refresh token en sessionStorage.
 *
 * Règle de sécurité : seul le refresh token est persisté — jamais l'access token
 * (courte durée de vie, mémoire uniquement). La clé est constante et unique
 * (`mada-talk.refresh-token`). L'accès au storage est isolé derrière try/catch :
 * un sessionStorage indisponible (restriction navigateur, mode privé…) ne doit
 * jamais faire échouer le flux d'authentification.
 */

export const REFRESH_TOKEN_STORAGE_KEY = 'mada-talk.refresh-token';

function readStorage(): Storage | null {
  try {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function saveRefreshToken(token: string): void {
  const storage = readStorage();
  if (!storage) return;
  try {
    storage.setItem(REFRESH_TOKEN_STORAGE_KEY, token);
  } catch {
    // Stockage indisponible : on ignore, la session reste utilisable en mémoire.
  }
}

export function loadRefreshToken(): string | null {
  const storage = readStorage();
  if (!storage) return null;
  try {
    return storage.getItem(REFRESH_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearRefreshToken(): void {
  const storage = readStorage();
  if (!storage) return;
  try {
    storage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  } catch {
    // Stockage indisponible : rien à nettoyer.
  }
}
